import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { RequestStatus } from "../../utils/Enums";
import {
    deleteVendor,
    getCurrentVendor,
    resetDeleteVendorStatus,
} from "../../store/reducers/VendorsSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import { LoggedInView } from "../common/LoggedInView";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";

interface DeleteVendorScreenProps {}

export const DeleteVendorScreen: React.FC<DeleteVendorScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const vendorsState = useAppSelector((state) => state.vendors);
    const requestStatus: RequestStatus = vendorsState.deleteVendorStatus;

    const { id } = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Hankijad", url: "/vendors" },
        { text: "Hankija kustutamine", url: `/vendors/${id}/delete` },
    ];

    useEffect(() => {
        dispatch(resetDeleteVendorStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteVendor({ id }));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentVendor({ id }));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Hankija kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{ textAlign: "center" }}>
                <div>
                    <h2>
                        Oled kindel, et soovid hankija{' '}
                        <em>{vendorsState?.currentVendor?.name ?? ""}</em> kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes" />
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};
